import React from "react"
import { Skeleton } from "antd"
import useMediaQuery from "@/utils/useMediaQuery"

const DeliveryOptionSkeletonCard: React.FC = () => {
  let isDesktop = useMediaQuery("(min-width: 1024px)")

  return (
    <div className="mb-3 rounded-lg border-2 p-3 flex flex-row">
      <Skeleton.Avatar
        size="large"
        shape="square"
        style={{
          borderRadius: "8px",
          marginRight: "1em",
          height: "3em",
          width: "3em",
        }}
      />
      <div className="my-auto flex flex-col w-full">
        <div className="flex flex-row mb-1">
          {isDesktop && (
            <Skeleton.Avatar
              active
              size="small"
              shape="square"
              style={{
                borderRadius: "8px",
                marginRight: "1em",
                height: "1.4em",
              }}
            />
          )}
          <Skeleton.Input
            active
            size="small"
            style={{ borderRadius: "8px", height: "1.4em" }}
            block
          />
        </div>
        <Skeleton.Input
          active
          size="small"
          style={{ borderRadius: "8px", height: "1.4em" }}
          block
        />
      </div>
    </div>
  )
}

export default DeliveryOptionSkeletonCard
